import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SharedModule } from '../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { priceTableConfig } from './core/price-table-config';
import { DialogService } from '../../../services/dialog/dialog.service';
import { PriceService } from '../../../services/price.service';
import { ToastService } from '../../../services/toast.service';
import { RouterLink } from '@angular/router';
import { Price } from '../../models/price/price';
import { AuthService } from '../../../services/auth/auth.service';
import { UserRole } from '../../models/user/user-role.enum';
import { PageTitleService } from '../../../services/page-title.service';
import { UserHasRolePipe } from '../../pipes/user-has-role.pipe';


@Component({
  selector: 'psc-prices',
  standalone: true,
  imports: [CommonModule, MatIconModule, NgxDatatableModule, SharedModule, TranslocoModule, RouterLink, UserHasRolePipe],
  templateUrl: './prices.component.html'
})
export class PricesComponent implements OnInit {

  loading: boolean;
  prices: Price[];
  columns = priceTableConfig.columns;

  constructor(
    private dialogService: DialogService,
    private priceService: PriceService,
    private toastService: ToastService,
    private authService: AuthService,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.prices)
     */
    this.pageTitleService.setTitle('title.prices');
  }

  ngOnInit() {
    this.getAllPrices();
    if (!this.authService.userHasRole(UserRole.ROLE_ADMIN)) {
      this.columns = this.columns.filter(col => col.prop !== 'direction' && col.prop !== 'privacyStatus');
    }
  }

  getAllPrices() {
    this.loading = true;
    this.priceService.getPrices(this.authService.userHasRole(UserRole.ROLE_ADMIN) ? 'public' : 'private').subscribe((parameters) => {
      this.prices = parameters;
      this.loading = false;
    });
  }

  deleteParameterClicked(priceId: string) {
    this.dialogService.openConfirmDialog(() => {
      this.priceService.deletePrice(priceId).subscribe(() => {
        this.getAllPrices();
        this.toastService.showSuccessToast();
      });
    });
  }

  protected readonly UserRole = UserRole;
}
